import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QRCodeComponent } from 'angularx-qrcode';
import { environment } from '../../environments/environment';

interface QRRedirect {
  id: string;
  name: string;
}

@Component({
  selector: 'app-qr-manager',
  standalone: true,
  imports: [CommonModule, QRCodeComponent],
  templateUrl: './qr-manager.component.html',
  styleUrl: './qr-manager.component.scss'
})
export class QrManagerComponent {
  // Uses environment config for different environments (local vs prod)
  readonly apiBaseUrl = environment.qrRedirectBaseUrl;
  
  redirects: QRRedirect[] = [
    { id: 'p1', name: 'Ashwagandha powder' },
    { id: 'p2', name: 'Beetroot powder' },
    { id: 'p3', name: 'Triphala powder' },
    { id: 'p4', name: 'Aamla powder' },
    { id: 'p5', name: 'Morning powder' },
  ];

  getRedirectUrl(id: string): string {
    return `${this.apiBaseUrl}${id}`;
  }

  printQR(id: string) {
    const canvas = document.querySelector(`#qr-${id} canvas`) as HTMLCanvasElement;
    if (canvas) {
      const dataUrl = canvas.toDataURL('image/png');
      const windowContent = `<!DOCTYPE html>
        <html>
        <head><title>QR Code - ${id}</title></head>
        <body style="display: flex; align-items: center; justify-content: center; height: 100vh; margin: 0;">
          <img src="${dataUrl}" style="width: 400px; height: 400px;" />
          <script>window.onload = () => { window.print(); setTimeout(() => window.close(), 500); }</script>
        </body>
        </html>`;
      const printWin = window.open('', '', 'width=600,height=600');
      printWin?.document.open();
      printWin?.document.write(windowContent);
      printWin?.document.close();
    }
  }
}
